@if (bannerImage) {
  <img [src]="bannerImage" (error)="imageError()" />
}
<app-center-section>
  <h1>{{ title }}</h1>
  <div [innerHTML]="description | sanitizeHtml" class="page-description rich-text"></div>
  @for (question of questions; track $index) {
    <app-accordion [title]="question.QuestionText" [text]="question.AnswerText"></app-accordion>
  }
</app-center-section>
